import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export type DeviceActiveSyncsState = EntityState<number>;

export function selectActiveDeviceSyncs(currentActiveDeviceSyncs: number): number {
  return currentActiveDeviceSyncs;
}

export const adapter: EntityAdapter<number> = createEntityAdapter<number>({
  selectId: selectActiveDeviceSyncs,
});

export const initialState: DeviceActiveSyncsState = adapter.getInitialState();
